{
  "tabs": {
    "chat": "Mokano",
    "reminders": "Mikano",
    "calendar": "Kalendrier",
    "settings": "Mise na esika"
  },
  "common": {
    "cancel": "Koboya",
    "save": "Kobomba",
    "confirm": "Komema",
    "delete": "Kosila",
    "back": "Kokende na nsuka",
    "close": "Kofungola",
    "edit": "Kosala lisusu",
    "search": "Kotalisa",
    "all": "Bakonzi nyonso",
    "loading": "Kofungola...",
    "error": "Likambo moko esili malamu te",
    "notFound": "Ezalaki te",
    "tryAgain": "Kobanda lisusu",
    "retry": "Kobanda lisusu",
    "undo": "Kobongisa",
    "pullToRefresh": "Kobundisa mpo na kobongisa",
    "justNow": "soki kaka"
  },
  "auth": {
    "welcome": "Boyei na FishMemory",
    "tagline": "Mokonzi na yo ya mikano ya WhatsApp, sikoyo na poche na yo.",
    "subtitle": "Mokonzi na yo ya mikano ya WhatsApp, sikoyo na poche na yo.",
    "phoneLabel": "Nɔmero na yo ya WhatsApp",
    "phoneHint": "Tokotindela code ya kokitisa na WhatsApp",
    "invalidPhone": "Kobakisa nɔmero ya telefone oyo ezali malamu",
    "continue": "Kobanda",
    "enterPhone": "Kobakisa nɔmero na yo ya WhatsApp",
    "phonePlaceholder": "Nɔmero ya telefone",
    "sendCode": "Tinda Code",
    "verifyTitle": "Kotika nɔmero na yo",
    "otpSentTo": "Code ya mibale na motuya 6 etindami na {{phone}} na WhatsApp",
    "enterFullCode": "Kobakisa mibale na motuya 6 nyonso",
    "invalidOtp": "Code ezali mabe. Kobanda lisusu.",
    "otpFailed": "Ezalaki mabe kotinda code. Kobanda lisusu.",
    "otpResent": "Code etindami lisusu",
    "resendIn": "Tinda lisusu na {{seconds}}s",
    "resendCode": "Tinda code lisusu",
    "enterOtp": "Kobakisa code oyo etindami na WhatsApp na yo",
    "verify": "Kotika",
    "resend": "Tinda code lisusu",
    "wrongNumber": "Nɔmero mabe?",
    "backToPhone": "Kokende na telefone",
    "editPhone": "Kosala lisusu nɔmero ya telefone",
    "error": "Likambo",
    "setupTitle": "Tosala makambo",
    "setupSubtitle": "Okoki kobongisa yango na nsima na Mise na esika",
    "namePlaceholder": "Kombo na yo",
    "letsGo": "Kokokisa setup",
    "skipForNow": "Koboya sikoyo"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Kobakisa maloba...",
    "inputPlaceholder": "Kobakisa maloba...",
    "typing": "FishMemory azali kokoma...",
    "online": "Na Internet",
    "connecting": "Kokutana...",
    "reconnecting": "Kokutana lisusu...",
    "offline": "Na Internet te",
    "empty": "Tanga mokano",
    "emptyHint": "Salela mikano, tala kalendrier na yo, to kosenga lisalisi.",
    "emptyAction": "Tinda mokano ya ndakisa",
    "actions": "Mikano ya mokano",
    "keep": "Kobatela mikano",
    "clearTitle": "Pona mokano",
    "clearConfirm": "Kosila mikano nyonso na appareil oyo? Ekozala te lisusu.",
    "clear": "Pona mokano",
    "optionSelected": "Omisami: {{label}}",
    "sendingSelection": "Koyebisa...",
    "connectionLost": "Kokutana lisusu..."
  },
  "reminders": {
    "title": "Mikano na ngai",
    "active": "Ekozala",
    "today": "Lelo",
    "thisWeek": "Semaine oyo",
    "history": "Mokanda",
    "items": "bilei",
    "emptyTitle": "Mikano te",
    "emptySubtitle": "Salela mokano na mokano mpe ekotala awa.",
    "emptyAction": "Fungola mokano",
    "filterActive": "Ekozala",
    "filterToday": "Lelo",
    "filterWeek": "Semaine oyo",
    "filterHistory": "Mokanda",
    "emptyState": "Mikano te. Tangá mokano!",
    "swipeDone": "Ekozala",
    "swipeSnooze": "Kobeta ntango",
    "swipeDelete": "Kosila",
    "search": "Kotalisa mikano...",
    "upcoming": "Ekozala",
    "completed": "Ekozami",
    "overdue": "Ezalaki",
    "tomorrow": "Lobi",
    "synced": "Ekomelaki {{value}}",
    "swipeHint": "Kobeta mokano mpo na misala mingi",
    "noResults": "Mikano te oyo esalemi na kotalisa",
    "noResultsHint": "Kobanda lisusu na maloba mosusu to pona kotalisa",
    "deleteAllFailed": "Ezalaki mabe kosila mikano nyonso"
  },
  "calendar": {
    "title": "Kalendrier",
    "today": "Lelo",
    "tomorrow": "Lobi",
    "completed": "Ekozami",
    "noEvents": "Likambo te",
    "noEventsSubtitle": "Kobakisa mokolo mpo na kotalisa mikano mpe likambo ya kalendrier.",
    "googleEvent": "Google Kalendrier",
    "legendActive": "Ekozala",
    "legendRecurring": "Ekozala lisusu",
    "legendDone": "Ekozami",
    "legendGoogle": "Google",
    "previousMonth": "Mokolo ya kala",
    "nextMonth": "Mokolo ya sima",
    "previousYear": "Mbula ya kala",
    "nextYear": "Mbula ya sima",
    "goToToday": "Kende na lelo",
    "all": "Bakonzi nyonso",
    "active": "Ekozala",
    "done": "Ekozami",
    "paused": "Ekomaki"
  },
  "settings": {
    "title": "Mise na esika",
    "profile": "Profil",
    "name": "Kombo ya kotala",
    "enterName": "Kobakisa kombo na yo",
    "language": "Lilingi",
    "uiLanguage": "Lilingi ya app",
    "uiLanguageHelp": "Ekokisa UI ya app, ba label ya kalendrier, mpe ndenge ya kokoma na appareil oyo kaka.",
    "serverLanguage": "Lilingi ya mokano",
    "serverLanguageHelp": "Ekokisa lilingi oyo serveur esalaka na yango mpe mikano ya compte na yo.",
    "timezone": "Ntango ya esika",
    "currentTimezone": "Ntango ya esika oyo ezali sikoyo",
    "timezoneHelp": "Ntango nyonso ya mikano ezali na ntango ya esika oyo.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Bomba ntango ya esika",
    "timezoneSaved": "Ntango ya esika ebongisami",
    "detect": "Kotalisa",
    "detectFailed": "Ezalaki mabe kotalisa ntango ya esika",
    "autoDetect": "Kotalisa na GPS",
    "notifications": "Mikano ya koyebisa",
    "notificationsHelp": "Mikano ya koyebisa esalaka ete okoki kozwa mikano ya sika nsima ya mikano ya kala. Mikano ya appareil ezali na mise na esika ya telefone na yo.",
    "pushEnabled": "Mikano ya koyebisa",
    "autoDoneOnFire": "Kokokisa mokano ntango etindami",
    "autoDoneOnFireDesc": "Soki ezali off, mikano ekobanda kozala tii okotika yango.",
    "googleCalendar": "Google Kalendrier",
    "google": "Google Kalendrier",
    "googleConnected": "Ekomaki",
    "googleDisconnected": "Ekomaki te",
    "googleConnectedHelp": "Mikano ya sika ekoki kozala na kalendrier na yo na ndenge ya automatique.",
    "googleDisconnectedHelp": "Kokutana na Google Kalendrier mpo na kobatela mikano mpe likambo.",
    "googleConnectFailed": "Ezalaki mabe kokutana na Google Kalendrier",
    "connected": "Ekomaki",
    "disconnected": "Ekomaki te",
    "connect": "Kokutana",
    "disconnect": "Kokanga",
    "autoSync": "Kobongisa mikano ya sika",
    "autosync": "Kobongisa mikano ya sika",
    "subscription": "Abonnement",
    "trialUsed": "Essai: {{used}}/{{total}} esalemi",
    "trialStatus": "Essai ezali",
    "activeStatus": "Abonnement ekomi",
    "expiredStatus": "Abonnement ekomi te",
    "unsubscribedStatus": "Abonnement te",
    "about": "Mokonzi",
    "version": "Version",
    "logout": "Kobima",
    "logoutTitle": "Kobima",
    "logoutConfirm": "Ozali na posa ya kobima?",
    "noName": "Kombo te",
    "serverConnection": "Kokutana na serveur",
    "serverUrl": "URL ya serveur",
    "serverEdit": "Kosala lisusu",
    "saveReconnect": "Bomba mpe kokutana lisusu",
    "resetDefault": "Kobongisa ndenge ya liboso",
    "invalidServerUrlTitle": "URL ya serveur ezali mabe",
    "invalidServerUrlMessage": "Kobakisa URL ya serveur oyo ezali malamu http to https, ndakisa https://example.com",
    "uiLanguageChangeFailed": "Ezalaki mabe kobongisa lilingi ya app. Kobanda lisusu.",
    "serverLanguageChangeFailed": "Ezalaki mabe kobongisa lilingi ya mokano. Kobanda lisusu.",
    "timezoneChangeFailed": "Ezalaki mabe kobongisa ntango ya esika. Kobanda lisusu.",
    "autoSyncChangeFailed": "Ezalaki mabe kobongisa kobongisa automatique. Kobanda lisusu.",
    "nameChangeFailed": "Ezalaki mabe kobongisa kombo ya kotala. Kobanda lisusu.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Mikano ya makambo",
    "editTime": "Kosala lisusu ntango",
    "rename": "Kobongisa kombo",
    "snooze": "Kobeta ntango",
    "snooze15": "Kobeta ntango na miniti 15",
    "pause": "Kokanga",
    "pauseReminder": "Kokanga mikano",
    "resume": "Kobanda lisusu",
    "resumeReminder": "Kobanda lisusu mikano",
    "skip": "Koboya oyo elandi",
    "skipOccurrence": "Koboya oyo elandi",
    "syncGoogle": "Kobongisa na Google",
    "delete": "Kosila",
    "deleteTitle": "Kosila Mikano",
    "deleteConfirm": "Mikano oyo ekosilama noki.",
    "deleteRecurringTitle": "Kosila Mikano ya kobongisa",
    "deleteRecurringMessage": "Ozali na posa ya koboya oyo elandi to kosila nyonso?",
    "deleteThisOccurrence": "Koboya oyo elandi",
    "deleteEntireSeries": "Kosila nyonso",
    "done": "Ekozami",
    "markDone": "Kobongisa lokola ekomami",
    "undo": "Kobongisa",
    "undoPrompt": "Ozali na posa ya kobongisa? Bonga sikoyo.",
    "recurring": "Ekozala lisusu",
    "nextRun": "Elandi",
    "oneTime": "Mokolo moko",
    "pending": "Ekozala",
    "sent": "Etindami",
    "paused": "Ekomaki",
    "active": "Ekozala",
    "snoozed": "Ebongisami",
    "localTime": "Ezalami na ntango ya esika na yo",
    "recurrence": "Kobongisa",
    "created": "Ezalaki",
    "tags": "Ba tag",
    "fireCount": "Nyonso ya kokamwa",
    "actions": "Misala",
    "none": "Te",
    "snoozeFailed": "Ezalaki mabe kobeta ntango ya mikano",
    "pauseFailed": "Ezalaki mabe kokanga mikano",
    "resumeFailed": "Ezalaki mabe kobanda lisusu mikano",
    "skipFailed": "Ezalaki mabe koboya mikano",
    "doneFailed": "Ezalaki mabe kobongisa mikano lokola ekomami",
    "undoFailed": "Ezalaki mabe kobongisa mikano",
    "deleteFailed": "Ezalaki mabe kosila mikano",
    "rescheduleTitle": "Kobongisa ntango?",
    "rescheduleMsg": "Mikano oyo ezalaki kala. Ozali na posa ya kobongisa ntango?",
    "reschedule15": "Na miniti 15",
    "reschedule60": "Na ngonga 1",
    "keepOverdue": "Kobatela ndenge ezali"
  },
  "onboarding": {
    "slide1Title": "Boyei na FishMemory",
    "slide1Sub": "Mokonzi na yo ya mikano — esalemi na WhatsApp mpe na poche na yo.",
    "slide2Title": "Tanga Maloba Malamu",
    "slide2Sub": "Kobakisa mikano ndenge oyebi: \"Lobela ngai kobenga mama lobi na 3pm\" — tosalaka mosala nyonso.",
    "slide3Title": "Kosalela Mikano",
    "slide3Sub": "Zwa mikano na ntango, salela ba tag, mpe tika makambo nyonso.",
    "getStarted": "Kobanda",
    "next": "Elandi",
    "firstReminderTitle": "Salela mikano ya liboso!",
    "firstReminderHint": "Kobanda na maloba lokola:",
    "firstReminderExample": "Lobela ngai komela mai lobi na 9 AM",
    "gotIt": "Nayebi!",
    "notifRationaleTitle": "Tika ntango",
    "notifRationaleBody": "FishMemory esengeli mikano mpo na koyebisa yo na ntango. Okokaki kozwa mikano kaka mpo na mikano oyo osalaka.",
    "notifRationaleAllow": "Tika mikano",
    "notifRationaleLater": "Mposo mosusu",
    "swipeHint": "Kobundisa na loboko ya mobali mpo na misala ya noki →",
    "calendarDragHint": "Bunda mpo na kobongisa ↕"
  }
}
